/**
 * @description Promise限制并发请求数量
 * @class promiseLimit
 * */

export default class PromiseLimit {
  constructor (limit = 6, chunksData, failedChunksIndex = [], callback, params, updateState, chunksProgress = 0) {
    this.limit = limit
    this.chunksData = chunksData
    this.index = 0
    // 上传事件
    this.callback = callback
    // 上传失败的分块索引
    this.failedChunksIndex = failedChunksIndex
    // 状态更新事件
    this.updateState = updateState
    // 参数
    this.params = params
    // 所有队列
    this.sequenceRet = []
    // 正在执行的队列
    this.sequenceExcuting = []
    // 已上传分块数量
    this.chunksProgress = chunksProgress
  }

  sequence = async () => {
    // 当前块
    let chunkFile
    if (this.failedChunksIndex.length > 0) {
      // 全部执行完毕
      if (this.index === this.failedChunksIndex.length) {
        return Promise.resolve()
      }
      this.params.index = this.failedChunksIndex[this.index++]
      chunkFile = this.chunksData[this.params.index]
    } else {
      // 全部执行完毕
      if (this.index === this.chunksData.length) {
        return Promise.resolve()
      }
      this.params.index = this.index
      chunkFile = this.chunksData[this.index++]
    }
    let p = Promise.resolve().then(() => this.callback(chunkFile, this.params))
    this.sequenceRet.push(p)
    // 如果执行完毕，从执行队列中删除
    let e = p.then(() => {
      this.chunksProgress += 1
      this.sequenceExcuting.splice(this.sequenceExcuting.indexOf(e), 1)
      // 更新进度条
      this.updateState(this.params.flag, this.chunksProgress, this.chunksData.length)
    })
    this.sequenceExcuting.push(e)
    let r = Promise.resolve()
    // 执行队列 >= 限制并发数时进行触发，结束后递归加入新的Promise实例
    if (this.sequenceExcuting.length >= this.limit) {
      r = Promise.race(this.sequenceExcuting)
    }
    await r
    return this.sequence()
  }
  excute = async () => {
    await this.sequence()
    return Promise.all(this.sequenceRet).then(() => {
      return Promise.resolve(this.chunksProgress)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/form/runtime/components/utils/promiseLimit.js